function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "reminder");

var _ref3 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 42.92792,
  cy: 681.97835,
  r: 13.68536,
  fill: "#4527a0"
});

var _ref4 =
/*#__PURE__*/
React.createElement("rect", {
  x: 230.71992,
  y: 658.953,
  width: 36,
  height: 36,
  fill: "#ff6584"
});

var _ref5 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 230.92792,
  cy: 682.97835,
  r: 13.68536,
  fill: "#4527a0"
});

var _ref6 =
/*#__PURE__*/
React.createElement("polygon", {
  points: "236.741 0 156.336 125.51 329.073 59.15 236.741 0",
  fill: "#f1f1f1"
});

var _ref7 =
/*#__PURE__*/
React.createElement("polygon", {
  points: "335.775 67.912 151.635 138.653 0 375.352 496.8 693.612 734.147 323.117 335.775 67.912",
  fill: "#f1f1f1"
});

var _ref8 =
/*#__PURE__*/
React.createElement("polygon", {
  points: "633.944 200.247 634.64 200.964 624.625 176.833 529.768 270.217 508.139 322.339 633.944 200.247",
  fill: "#4527a0"
});

var _ref9 =
/*#__PURE__*/
React.createElement("polygon", {
  points: "624.212 175.837 612.456 147.507 551.082 218.857 531.737 265.474 623.511 175.124 624.212 175.837",
  fill: "#4527a0"
});

var _ref10 =
/*#__PURE__*/
React.createElement("polygon", {
  points: "611.269 145.82 612.026 146.473 596.573 109.235 553.541 212.932 611.269 145.82",
  fill: "#4527a0"
});

var _ref11 =
/*#__PURE__*/
React.createElement("polygon", {
  points: "718.164 402.235 635.052 201.958 506.202 327.005 474.983 402.235 353.393 695.235 596.573 695.235 839.754 695.235 718.164 402.235",
  fill: "#4527a0"
});

var _ref12 =
/*#__PURE__*/
React.createElement("line", {
  x1: 7.80805,
  y1: 695.2348,
  x2: 868.3388,
  y2: 695.2348,
  fill: "none",
  stroke: "#3f3d56",
  strokeMiterlimit: 10,
  strokeWidth: 2
});

var _ref13 =
/*#__PURE__*/
React.createElement("polygon", {
  points: "647.508 510.235 563.073 620.65 563.073 664.898 673.283 510.235 647.508 510.235",
  fill: "#3f3d56"
});

var _ref14 =
/*#__PURE__*/
React.createElement("polygon", {
  points: "611.229 510.235 563.073 568.354 563.073 617.358 644.991 510.235 611.229 510.235",
  fill: "#3f3d56"
});

var _ref15 =
/*#__PURE__*/
React.createElement("polygon", {
  points: "608.632 510.235 563.073 510.235 563.073 565.219 608.632 510.235",
  fill: "#3f3d56"
});

var _ref16 =
/*#__PURE__*/
React.createElement("polygon", {
  points: "675.738 510.235 563.073 668.344 563.073 695.235 843.073 695.235 843.073 510.235 675.738 510.235",
  fill: "#3f3d56"
});

var _ref17 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 795.07343,
  cy: 405.2348,
  r: 79,
  fill: "#2f2e41"
});

var _ref18 =
/*#__PURE__*/
React.createElement("rect", {
  x: 970.03671,
  y: 568.90295,
  width: 24,
  height: 43,
  transform: "translate(1801.11014 1079.13775) rotate(-180)",
  fill: "#2f2e41"
});

var _ref19 =
/*#__PURE__*/
React.createElement("rect", {
  x: 922.03671,
  y: 568.90295,
  width: 24,
  height: 43,
  transform: "translate(1705.11014 1079.13775) rotate(-180)",
  fill: "#2f2e41"
});

var _ref20 =
/*#__PURE__*/
React.createElement("ellipse", {
  cx: 811.07343,
  cy: 510.7348,
  rx: 20,
  ry: 7.5,
  fill: "#2f2e41"
});

var _ref21 =
/*#__PURE__*/
React.createElement("ellipse", {
  cx: 763.07343,
  cy: 509.7348,
  rx: 20,
  ry: 7.5,
  fill: "#2f2e41"
});

var _ref22 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 793.07343,
  cy: 385.2348,
  r: 27,
  fill: "#fff"
});

var _ref23 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 793.07343,
  cy: 385.2348,
  r: 9,
  fill: "#3f3d56"
});

var _ref24 =
/*#__PURE__*/
React.createElement("path", {
  d: "M1034.66938,433.43522c6.37889-28.56758-14.01185-57.43391-45.544-64.47476s-62.2651,10.41-68.644,38.97759S935,447.04185,966.53215,454.0827,1028.29049,462.0028,1034.66938,433.43522Z",
  transform: "translate(-162.96329 -101.66814)",
  fill: "#4527a0"
});

var _ref25 =
/*#__PURE__*/
React.createElement("line", {
  x1: 178.07343,
  y1: 394.2348,
  x2: 178.07343,
  y2: 695.2348,
  fill: "none",
  stroke: "#3f3d56",
  strokeMiterlimit: 10,
  strokeWidth: 2
});

var _ref26 =
/*#__PURE__*/
React.createElement("rect", {
  x: 3.07343,
  y: 278.2348,
  width: 350,
  height: 232,
  fill: "#4527a0"
});

var _ref27 =
/*#__PURE__*/
React.createElement("rect", {
  x: 43.07343,
  y: 336.2348,
  width: 270,
  height: 8,
  fill: "#f1f1f1"
});

var _ref28 =
/*#__PURE__*/
React.createElement("rect", {
  x: 43.07343,
  y: 363.2348,
  width: 270,
  height: 8,
  fill: "#f1f1f1"
});

var _ref29 =
/*#__PURE__*/
React.createElement("rect", {
  x: 43.07343,
  y: 390.2348,
  width: 270,
  height: 8,
  fill: "#f1f1f1"
});

var _ref30 =
/*#__PURE__*/
React.createElement("rect", {
  x: 243.07343,
  y: 444.2348,
  width: 70,
  height: 8,
  fill: "#f1f1f1"
});

var _ref31 =
/*#__PURE__*/
React.createElement("ellipse", {
  cx: 178.07343,
  cy: 278.2348,
  rx: 30,
  ry: 16,
  fill: "#3f3d56"
});

var SvgUndrawReminderPa79 = function SvgUndrawReminderPa79(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    id: "ab6d4b78-a8f6-485a-afcf-f519a4f8db63",
    "data-name": "Layer 1",
    width: 874.07343,
    height: 696.66371,
    viewBox: "0 0 874.07343 696.66371",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? React.createElement("title", null, title) : null, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgUndrawReminderPa79, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/undraw_reminder_pa79.47c98f6e.svg";
export { ForwardRef as ReactComponent };